import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";


 
//查询列表 GET /DeviceOrder/findList
export  const findList =(params)=>{
    return http.get('/DeviceOrder/findList',params)
  }

//新增 POST /DeviceOrder/insert
export function add(params){
    return http.postJSON("/DeviceOrder/insert",params);
  }

  //编辑POST /DeviceOrder/update
  export function update(params){
    return http.postJSON("/DeviceOrder/update",params);
  }

  //导出GET /DeviceOrder/exportExcel
  export function exportExcel(params) {
    return http.getExcel("/DeviceOrder/exportExcel",params,"导出")
 }
 //GET /DeviceOrder/loadAllOrder
 export  const loadAllOrder =(params)=>{
  return http.get('/DeviceOrder/loadAllOrder',params)
}


// WEBPACK FOOTER //
// ./src/services/deviceOrder.js